import React, { useContext, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { USER_CONTEXT } from '../context/ContextProvider'
import CreateFrom from '../section/CreateFrom'
import TaskCard from '../components/TaskCard'
import { useUser } from '@clerk/clerk-react'

const Edit = () => {
  let { user } = useUser()
  let { id } = useParams()
  let formRef = useRef(null)
  let { data } = useContext(USER_CONTEXT)
  let task = data.tasks.find((task) => task.id == id)
  return (
    <>
      <div className="flex relative pb-5">
        <div className="md:w-[70%] w-full">
          <div className="flex justify-between">
            <h4 className="text-3xl font-medium text-white">Edit Task ✏️</h4>
          </div>
          <div className="mt-8 bg-[#1E1F25] p-[30px] rounded-xl">
            <CreateFrom formRef={formRef} defaultValue={task} edit={true}/>
          </div>
        </div>
        <div className="hidden md:block sticky w-[30%] h-full top-24 right-0 pl-5">
          <div className="flex justify-between">
            <h4 className="text-2xl font-medium text-white ">
              Live Preview 👁️‍🗨️
            </h4>
          </div>
          <div className="mt-8 w-full">
            <TaskCard
              data={{
                createdAt: 'Dec 5, 2023',
                tags: 'Research',
                tagline: 'Create a production buld for new github branch',
                title: 'Github Production Build',
                creator: {
                  avatar: user.profileImageUrl,
                  name: user.fullName,
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default Edit
